// extracted by mini-css-extract-plugin
var _1 = "agreement-card__aozHf";
export { _1 as "agreementCard" }
